import {MI} from "../init";
import AbstractSymbol from "../symbol/AbstractSymbol";
import MadnesTween from "../libs/mi/MadnesTween";
import FreeSpinOption from "./FreeSpinOption";
import SymbolFlask from "../symbol/SymbolFlask";
import Alchemist from "./Alchemist";
import ChangeFlyAnim from "./ChangeFlyAnim";
import {getRandomFloat, getRandomInt} from "../../framework/src/helpers";
import {states, systemConfig} from "../../framework/src/engine/madnes/madnes_variables";
import {STATES} from "../../framework/src/states/states";
import {
    madnes_set_alpha,
    madnes_set_angle,
    madnes_set_pos,
    madnes_set_pos_y
} from "../../framework/src/engine/madnes/madnes_object";
import {madnes_start_freespins} from "../../framework/src/engine/madnes/madnes";
import WinLineText from "./WinLineText";
import WinViewer from "./WinViewer";
import Shuffling from "../Shuffling";
import { CONFIG_PARAMS, MODES } from "../../framework/src/system/SystemConfig";

/**
 * @constructor
 * @param {Game} game
 * @param {ResultController} resultController
 * @param {SymbolsManager} symbolsManager
 * @returns {WinControl}
 */

export default function WinControl(game, resultController, symbolsManager, serverResult) {

    /** @type {Game}  */
    this._game = game;

    /** @type {Object<string,MadnesAudio>} */
    this._sounds = game.sounds;

    /** @type {ResultController} */
    this._resultController = resultController;

    /** @type {SpinReels} */
    this._reels = game.spinReels;

    /** @type {Function|null} */
    this._resolver;

    /** @type {ServerResultWinline} */
    this._winline;

    /** @type {SymbolsManager} */
    this._symbolsManager = symbolsManager;

    /** @type {Array<AbstractSymbol>} */
    //this._animsSymbols = [];

    /** @type {Array<FreeSpinOption>} */
    this._fsOptions = [];

    /** @type {boolean} */
    this.runned = false;

    //this.resolve = function() {};

    this.nextWinLine = null;

    /** @type {boolean} */
    this._bigWinRunned = false;

    /** @type {MadnesTimer} */
    this._optionsBlinkTimer;

    /** @type {MadnesTimer} */
    this._optionsTimer;

    this._chooseTimeout = 30000;

    /** @type {Array<MadnesObject>} */
    this._fsParticles = [];
    this._playFsParticles = false;

}

WinControl.prototype = {

    init: function() {
        return new Promise(function(res) {
            this._resolver = res;
        }.bind(this));
    },

    getSoundName: function (symbolNum) {
        switch(AbstractSymbol.getSymbolByNum(symbolNum)) {
            case "symbol_J": return "win_FlaskLow_";
            case "symbol_Q": return "win_FlaskMid_";
            case "symbol_K": case "symbol_A": return "win_FlaskHigh_";
            case "symbol_Candle": return "win_Candle_";
            case "symbol_Pestle": return "win_Pestle_";

            case "symbol_Ring": return "win_Ring_";
            case "symbol_Crystal_blue": return "win_BlueCrystal_";
            case "symbol_Crystal_red": return "win_RedCrystal_";
            case "symbol_Gold": return "win_Coin_";
            default: return "";
        }
    },

    playWinlineSound: function(symbolNum, count) {

        var soundName = this.getSoundName(symbolNum);
        if(!soundName) {
            return;
        }

        this._sounds[soundName + count + "x"].play();

    },

    runBigwin: function() {
        return this._resultController.isBigWin() &&
            (this._winline.getType() === "normal" || this._winline.getType() === "wild") &&
            !this._bigWinRunned;
    },

    setNextWinLine: function(winline) {
        this.nextWinLine = winline;
    },

    /**
     *
     * @returns {number}
     */
    _incControlResultPos: function() {
        //console.log('inc', this._resultController._controlResultPos + 1);
        return this._resultController.incControlResultPos();
    },

    /**
     * @param {ServerResult} serverResult
     * @returns {Array}
     */
    _getReelMatrix: function(serverResult) {
        var resIdx = this._resultController.getControlResultPos();
        return serverResult.getReelMatrix(resIdx);
    },

    /**
     * @returns {Promise}
     */
    _onWinlineEnd: function(fromSkip) {

        this.addWin();

        var _self = this;

        if(_self.nextWinLine) {
            return Promise.resolve();
        }

        return new Promise(function(res) {
            if(fromSkip && !_self._resultController.isBigWin() && _self._game.inFreeSpins) {

                var won = _self._game.freeSpinData['roundWin'];

                var winCounter = new WinViewer(_self._game);
                winCounter.create(MI.moneyToCoin(won));
                winCounter.run().then(res);

            } else {
                res();
            }

        }).then(function() {

            if(_self._game.inFreeSpins && !_self._game.isNextRoundFreeSpin()) {
                return new Promise(function(res) { res(); });
            }

            return _self._reels.fadeOutBlackScreen();
        });
    },

    addWin: async function() {
        if(this._winline.getWin()) {
            if (!this._resultController.isBigWin())
                await this._game.addWin(this._winline.getWin() * 1);

            //this._game.gameRoundWin += this._winline.getWin();
            //this._game.gameTotalCredit += this._game.gameRoundWin;
        }
    },

    _muteBgMusic: function() {

        var soundName = this._game.inFreeSpins ? "bg_FreeSpins_Loop" : "bg_Music";

        var linePos = this._resultController.getControlLinePos();

        if(linePos === 0 && !this._resultController.inBigWin) {

            if(this._sounds["bg_FreeSpins_Start"].isPlaying()) {
                this._sounds["bg_FreeSpins_Start"].fadeToPerc(500, 0.5);
            }

            this._sounds[soundName].fadeToPerc(500, 0.5);
        }
    },

    /**
     * @param {ServerResultWinline} winline
     * @param {ServerResult} serverResult
     */
    run: function(winline, serverResult) {

        this._runned = true;

        //this.resolve = new Promise(function(res) {
        //this._resolver = res;
        //}.bind(this));

        if(!this._resolver) throw new Error("resolver not set!! call init() first");

        this._winline = winline;

        /*if(this._game.inFreeSpins) { //skip animations
            this.addWin();
            this._resolver();
            return;
        }*/

        if(this.runBigwin()) {
            this._bigWinRunned = true;
            this._resultController.runBigWin();//.then(this._resolver);
            this._resolver = null;
            return;
        }

        var type = this._winline.getType();

        if((type === "normal" || type === "wild") && MI.controls.winAnimSkipClicked() && !this._resultController.inBigWin) {
            type = "_skip";
        }

        switch(type) {
            case "_skip":
                this._animSkip();
                break;
            case "normal":
                this._animNormal();
                break;
            case "wild":
                this._animWild();
                break;
            case "spread":
                this._animSpread();
                break;
            case "shuffle":
                this._animShuffle(serverResult);
                break;
            case "appear":
                this._animAppear();
                break;
            case "freeSpins":
                this._animFreeSpins(serverResult);
                break;
            case "change":
                this._animChange();
                break;
            case "multiplier":
                this._animMultiplier();
                break;

            default:
                //console.warn("winline type not defined");
                this._resolver();
                break;
        }
    },

    _animSkip: function() {

        var _self = this;

        return this._onWinlineEnd(true).then(function() {
            _self._resolver();
        });


    },

    /**
     * @returns {undefined}
     */
    _animNormal: function() {

        if(!this._resultController.inBigWin)
        {
            states.setState(STATES.SKIP);
            // MI.controls.showAllBtns();
        }

        this._muteBgMusic();

        var multiplier = this._winline.getMultiplier();

        if(MI.controls.winAnimSkipClicked() && !this._resultController.inBigWin) {
            this._resolver();
            return;
        }

        MI.controls.winAnimAdd();

        var resSymbols = this._getResSymbols(this._winline.getPosition());
        var animsSymbols = this._createAnimsSymbols(resSymbols, this._winline.getSymbol());

        for(var i = 0; i < animsSymbols.length; i++) {
            animsSymbols[i].createWinSymbol();
            animsSymbols[i].setVisible(false);
        }

        for(var i = 0; i < resSymbols.length; i++) {
            this._reels.animsSymbolsGroup.add(resSymbols[i].getSprite());
            this._reels.animsSymbolsGroup.add(animsSymbols[i].getSprite());
        }

        this._reels.fadeInBlackScreenPre().then(function() {
            //console.time("normal");
            this.playWinlineSound(this._winline.getSymbol(), this._winline.getPosition().length);

            for(var i = 0; i < resSymbols.length; i++) {
                if(typeof resSymbols[i].stopOnWinAnim !== 'undefined') {
                    resSymbols[i].stopOnWinAnim();
                }
            }

            this._game.assets.frameFiresScaleIn();
            this._playWinLineTextNormal(animsSymbols, multiplier);
            return this._playWinlineAnim(animsSymbols);

        }.bind(this)).then(function() {

            this._game.assets.frameFiresScaleOut();
            return this._fadeOutSymbols(animsSymbols, 100);

        }.bind(this)).then(function() {

            for(var i = 0; i < resSymbols.length; i++) {
                if(typeof resSymbols[i].playOnWinAnim !== 'undefined') {
                    resSymbols[i].playOnWinAnim();
                }
            }

            for(var i = 0; i < animsSymbols.length; i++) {
                animsSymbols[i].destroyWinAnim();
                animsSymbols[i].destroy();

                resSymbols[i].setVisible(true);
            }

            //console.timeEnd("normal");
            return this._onWinlineEnd();

        }.bind(this)).then(function() {

            for(var i = 0; i < resSymbols.length; i++) {
                this._reels.symbolsGroup.add(resSymbols[i].getSprite());
            }

            this._resolver();

        }.bind(this));
    },

    /**
     * @returns {undefined}
     */
    _animWild: function() {

        if(!this._resultController.inBigWin)
        {
            states.setState(STATES.SKIP);
            // MI.controls.showAllBtns();
        }

        this._muteBgMusic();

        if(MI.controls.winAnimSkipClicked() && !this._resultController.inBigWin) {
            this._resolver();
            return;
        }

        MI.controls.winAnimAdd();

        var resSymbols = this._getResSymbols(this._winline.getPosition());
        var animsSymbols = this._createAnimsSymbols(resSymbols, this._winline.getSymbol());

        for(var i = 0; i < animsSymbols.length; i++) {
            animsSymbols[i].createWinSymbol();
            animsSymbols[i].setVisible(false);
        }

        //console.log(this._reels.getAllReelSymbols());

        for(var i = 0; i < resSymbols.length; i++) {

            if(resSymbols[i].spreaded) {
                this._reels.spreadSymbolsGroup.add(resSymbols[i].getSprite());
            } else {
                this._reels.animsSymbolsGroup.add(resSymbols[i].getSprite());
            }

            this._reels.animsSymbolsGroup.add(animsSymbols[i].getSprite());
        }

        this._reels.fadeInBlackScreenPre().then(function() {

            //console.time("wild");
            var wildSymbols = this._getWildSymbols(animsSymbols);

            this._sounds["win_Expand_" + getRandomInt(1, 3)].play();

            for(var i = 0; i < wildSymbols.length; i++) {
                var reelX = wildSymbols[i].getReelX();

                var spreaded = this._reels.getSpreadedFromReel(reelX);
                spreaded.createConjureAnim(wildSymbols[i].getShineColor());
                spreaded.playConjureAnim();
            }

            var prom = this._scaleInSymbols(wildSymbols);
            //this._smokeSymbols(wildSymbol);

            return prom;

        }.bind(this)).then(function() {

            this.playWinlineSound(this._winline.getSymbol(), this._winline.getPosition().length);

            for(var i = 0; i < resSymbols.length; i++) {
                if(typeof resSymbols[i].stopOnWinAnim !== 'undefined') {
                    resSymbols[i].stopOnWinAnim();
                }
            }

            this._game.assets.frameFiresScaleIn();
            this._playWinLineTextNormal(animsSymbols);

            var wildSymbols = this._getWildSymbols(animsSymbols);
            this._playWildBgAnim(wildSymbols);

            return this._playWinlineAnim(animsSymbols);

        }.bind(this)).then(function() {

            this._game.assets.frameFiresScaleOut();
            return this._fadeOutSymbols(animsSymbols, 120);

        }.bind(this)).then(function() {

            for(var i = 0; i < resSymbols.length; i++) {
                if(typeof resSymbols[i].playOnWinAnim !== 'undefined') {
                    resSymbols[i].playOnWinAnim();
                }
            }

            for(var i = 0; i < animsSymbols.length; i++) {
                animsSymbols[i].destroyWinAnim();
                animsSymbols[i].destroy();

                if(this._symbolsManager.isHideable(resSymbols[i])) {
                    resSymbols[i].setVisible(false);
                } else {
                    resSymbols[i].setVisible(true);
                }
            }

            //console.timeEnd("wild");
            return this._onWinlineEnd();

        }.bind(this)).then(function() {

            for(var i = 0; i < resSymbols.length; i++) {

                if(resSymbols[i].spreaded) {
                    this._reels.spreadSymbolsGroup.add(resSymbols[i].getSprite());
                } else {
                    this._reels.symbolsGroup.add(resSymbols[i].getSprite());
                }
            }

            setTimeout(function() {
                this._resolver();
            }.bind(this), 100);

        }.bind(this));
    },

    /**
     * @returns {undefined}
     */
    _animSpread: function() {
        var _self = this;

        // MI.controls.hideAllBtns();
        states.setState(STATES.BONUS);

        this._muteBgMusic();

        this._incControlResultPos();

        var resSymbols = this._getResSymbols(this._winline.getPosition());
        var spreadSymbols = this._createSpreadSymbols(resSymbols);

        this._setSpreadedReels(spreadSymbols);

        this._playSpreadAnim(spreadSymbols).then(function() {

            for(var i = 0; i < spreadSymbols.length; i++) {
                var reelX = spreadSymbols[i].getReelX();
                var reelY = spreadSymbols[i].getReelY();

                var reelSymbols = _self._getReelSymbols(spreadSymbols[i].reelPos['x']);

                for(var j = 0; j < reelSymbols.length; j++) {

                    var sData = _self._symbolsManager.getSymbolData(reelSymbols[j]);
                    reelSymbols[j].destroy();

                    var symbol = _self._symbolsManager.create("symbol_Alchemist", sData['px'], sData['py'], sData['rx'], sData['ry']);
                    _self._reels.addSymbol(symbol);
                }

                _self._reels.getReel(reelX).reelSymbols[reelY].destroy();
                _self._reels.getReel(reelX).reelSymbols[reelY] = spreadSymbols[i];
                _self._reels.spreadSymbolsGroup.add(spreadSymbols[i].getSprite());
            }

            return _self._onWinlineEnd();

        }).then(function() {
            _self._resolver();
        });
    },

    /**
     * @param {Array<AbstractSymbol>} symbols
     * @returns {Array<AbstractSymbol>}
     */
    _getWildSymbols: function(symbols) {
        var wilds = [];
        for(var i = 0; i < symbols.length; i++) {

            var reelX = symbols[i].getReelX();
            if(this._reels.getReel(reelX).spreaded) {
                wilds.push(symbols[i]);
            }
        }
        return wilds;
    },

    _scaleInSymbols: function(symbols) {
        return new Promise(function(res) {
            for(var i = 0; i < symbols.length; i++) {

                (function(symbol) {
                    symbol.setScale(0, 0);
                    symbol.setVisible(true);
//					var x = symbol.getPosX();
//					var y = symbol.getPosY();

                    MI.addTween().to(symbol.getSprite(), { 'x': 1, 'y': 1 }, {
                        'scale': true,
                        'duration': 500,
                        'easing': MadnesTween.getEasing("back_out"),
                        'callback': res/*function() {

							res();
						}.bind(this)*/
                    });
                }.bind(this)(symbols[i]));
            }
        }.bind(this));
    },

    _smokeSymbols: function(symbols) {
        for(var i = 0; i < symbols.length; i++) {
            (function(symbol) {
                symbol.setScale(0, 0);
                symbol.setVisible(true);
                var x = symbol.getPosX();
                var y = symbol.getPosY();

                this._game.assets.dust(x, y, 1, 0, symbol.getShineColor(), 0);
            }.bind(this)(symbols[i]));
        }
    },

    /**
     * @param {Array<AbstractSymbol>} symbols
     * @returns {Array<AbstractSymbol>}
     */
    _createSpreadSymbols: function(symbols) {
        var spreadSymbols = [];

        for(var i = 0; i < symbols.length; i++) {

            var symbol = symbols[i];
            var x = symbol.getPosX();
            var y = symbol.getPosY();
            var reelX = symbol.reelPos['x'];
            var reelY = symbol.reelPos['y'];
            var symbolNum = symbol.getSymbolNum();

            var spreadSymbol = this._symbolsManager.create(symbolNum, x, y, reelX, reelY, symbols[i].spriteName + "_SPREAD");
            spreadSymbol.createSpreadSymbol(AbstractSymbol.getSpreadDirection(reelY), false);

            this._reels.spreadSymbolsGroup.add(spreadSymbol.getSprite());

            spreadSymbols.push(spreadSymbol);

        }

        return spreadSymbols;
    },

    /**
     * @param {Array<AbstractSymbol>} spreadSymbols
     * @returns {undefined}
     */
    _setSpreadedReels: function(spreadSymbols) {
        for(var i = 0; i < spreadSymbols.length; i++) {
            var reelX = spreadSymbols[i].getReelX();
            this._reels.getReel(reelX).spreaded = true;
        }
    },

    /**
     * @param {Array} positions
     * @returns {Array<AbstractSymbol>}
     */
    _getResSymbols: function(positions) {
        return this._reels.getResSymbols(positions);
    },

    /**
     * @returns {Array<AbstractSymbol>}
     */
    _getAllResSymbols: function() {
        return this._reels.getAllReelSymbols();
    },

    /**
     * @param {number} reelX
     * @param {number} reelY
     * @param {AbstractSymbol} symbol
     */
    _setResSymbol: function(reelX, reelY, symbol) {
        this._reels.getReel(reelX).reelSymbols[reelY] = symbol;
    },

    /**
     * @param {number} reelX
     * @returns {Array<AbstractSymbol>}
     */
    _getReelSymbols: function(reelX) {
        return this._reels.getReel(reelX).reelSymbols;
    },

    /**
     * @param {Array<AbstractSymbol>} resSymbols
     * @param {string|number=} symbolId
     * @returns {Array<AbstractSymbol>}
     */
    _createAnimsSymbols: function(resSymbols, symbolId) {

        var animsSymbols = [];

        for(var i = 0; i < resSymbols.length; i++) {
            animsSymbols.push(this._createAnimSymbol(resSymbols[i], symbolId));
        }

        return animsSymbols;
    },

    /**
     * @param {AbstractSymbol} resSymbol
     * @param {string|number=} symbolId
     * @returns {AbstractSymbol}
     */
    _createAnimSymbol: function(resSymbol, symbolId) {
        /** @type AbstractSymbol */
        var animSymbol = this._symbolsManager.createFromSymbol(resSymbol, symbolId, resSymbol.spriteName + "_ANIM");
        animSymbol.setReelPos(resSymbol.getReelX(), resSymbol.getReelY());

        return animSymbol;
    },

    /**
     * @param {Array<AbstractSymbol>} symbols
     * @returns {Promise}
     */
    _playWinlineAnim: function(symbols) {

        return new Promise(function(res) {
            //var proms = [];

            for(var i = 0; i < symbols.length; i++) {
                symbols[i].setVisible(true);
                symbols[i].playWinAnim().then(res);
                //proms.push();
            }

            //Promise.all(proms).then(res);

        }.bind(this));
    },

    _playWildBgAnim: function(wildSymbols) {

        for(var i = 0; i < wildSymbols.length; i++) {
            var reelX = wildSymbols[i].getReelX();
            var spreaded = this._reels.getSpreadedFromReel(reelX);
            spreaded.playBgAnim(wildSymbols[i].getShineColor());
        }

//		for(var i = 0; i < symbols.length; i++) {
//
//			if(typeof symbols[i].playBgAnim !== 'undefined') {
//				symbols[i].playBgAnim().then(res);
//			}
//		}

    },

    /**
     * @param {Array<AbstractSymbol>} spreadSymbols
     * @returns {Promise}
     */
    _playSpreadAnim: function(spreadSymbols) {

        var _self = this;

        this._sounds["bonus_Wild_Expand_Online"].play();

        return new Promise(function(res) {

            MI.createTimer().add(function() {

                for(var i = 0; i < spreadSymbols.length; i++) {

                    (function(spreadSymbol) {

                        var reelSymbols = _self._getReelSymbols(spreadSymbol.reelPos['x']);

                        for(var j = 0; j < reelSymbols.length; j++) {
                            (function(reelSymbol) {
                                reelSymbol.stopStandAnim();
                                MI.addTween().to(reelSymbol.getSprite(), { 'alpha': 0 }, {
                                    'duration': 300,
                                    'callback': function() {
                                        reelSymbol.setVisible(false);
                                    }
                                });
                            } (reelSymbols[j]));
                        }

                        var reel = _self._reels.getReel(spreadSymbol.reelPos['x']);
                        setTimeout(function() {
                            _self._game.assets.colorizeReelFrames(reel, spreadSymbol.getShineColor());
                        }, 300);

                        spreadSymbol.playSpreadAnim().then(res);

                    } (spreadSymbols[i]));
                }
            }, 200);
        });
    },

    _fadeOutSymbols: function(symbols, duration) {
        return new Promise(function(res) {
            for(var i = 0; i < symbols.length; i++) {
                (function(symbol) {

                    MI.addTween().to(symbol.getSprite(), { 'alpha': 0 }, {
                        'duration': duration,
                        'callback': res
                    });

                } (symbols[i]));
            }
        });
    },

    _animChange: function() {

        var _self = this;

        //MI.controls.hideAllBtns();
        states.setState(STATES.BONUS);


        var alchemist = new Alchemist(this._game.assets.getAlchemistGroup(), this._game.assets);
        alchemist.createChanging();

        this._muteBgMusic();

        this._incControlResultPos();

        var toSymbol = this._winline.getSymbol();

        var resSymbols = this._getResSymbols(this._winline.getPosition());
        var animsSymbols = this._createAnimsSymbols(resSymbols, toSymbol);

        for(var i = 0; i < animsSymbols.length; i++) {
            animsSymbols[i].createWinSymbol();
            animsSymbols[i].setVisible(false);
        }

        var proms = [];

        var sounds = 0;

        var color = animsSymbols[0].getShineColor();

        _self._game.sounds['bonus_Wild_Changing_1'].play();

        var fliesGroup = MI.addGroup();
        var filesGroup2 = _self._game.assets.fliesGroup;

        alchemist.playChanging(color, function() {
            _self._game.sounds['bonus_Wild_Changing_2'].play();
        }).then(function() {

            for(var i = 0; i < resSymbols.length; i++) {

                var prom = new Promise(function(res) {

                    (function(resSymbol, animSymbol, res, i) {

                        MI.createTimer().add(function() {

                            var flyParticle = MI.addImg(1110, 430, "changing_particle_" + SymbolFlask.getParticleColor(toSymbol))
                                .setAnchor(0.5, 0.5).setBlend("ADD").setScale(0.7, 0.7); //.setScale(2, 2);
                            fliesGroup.add(flyParticle);

                            if(i === resSymbols.length - 1) {
                                alchemist.changingCloseBottle();
                            }

                            var fly = new ChangeFlyAnim();
                            fly.run(flyParticle, resSymbol, 0, function() {

                                filesGroup2.add(flyParticle);

                            }).then(function() {

                                sounds++;
                                _self._sounds["bonus_Wild_Changing_3_" + sounds].play();

                                //flyParticle.setVisible(false);
                                flyParticle.destroy();

                                var newResSymbol = _self._symbolsManager.createFromSymbol(resSymbol, toSymbol);

                                resSymbol.stopStandAnim();
                                resSymbol.destroy();

                                _self._reels.animsSymbolsGroup.add(animSymbol.getSprite());
                                _self._game.assets.colorizeReelFramesBySymbol(newResSymbol);
                                animSymbol.setVisible(true);
                                animSymbol.playWinAnim().then(function() {

                                    newResSymbol.createSymbol();
                                    newResSymbol.createStandAnim();

                                    MI.addTween().to(animSymbol.getSprite(), { 'alpha': 0 }, {
                                        'duration': 200,
                                        'callback': function() {
                                            newResSymbol.playStandAnim();
                                            animSymbol.destroy();
                                            res();
                                        }
                                    });
                                });

                                _self._reels.addSymbol(newResSymbol);
                                _self._reels.symbolsGroup.add(newResSymbol.getSprite());
                            });

                        }, i * 300);
                    }(resSymbols[i], animsSymbols[i], res, i));

                });

                proms.push(prom);
            }

            Promise.all(proms).then(function() {

                _self._game.sounds['bonus_Wild_Changing_4'].play();
                alchemist.hideChanging(color);
                alchemist = null;

                MI.createTimer().add(function() {
                    //MI.controls.showAllBtns();
                    fliesGroup.destroy();
                    _self._resolver();
                }, 1010);
            });
        });

        /*for(var i = 0; i < resSymbols.length; i++) {
            this._reels.animsSymbolsGroup.add(resSymbols[i].getSprite());
        }*/

    },

    _animAppear: function() {

        //MI.controls.hideAllBtns();
        states.setState(STATES.BONUS);


        this._muteBgMusic();

        this._sounds["symbol_Wild_Start"].play();

        this._incControlResultPos();

        var resSymbols = this._getResSymbols(this._winline.getPosition());
        var animsSymbols = this._createAnimsSymbols(resSymbols, "symbol_Alchemist");

        var proms = [];

        for(var i = 0; i < resSymbols.length; i++) {
            this._reels.animsSymbolsGroup.add(animsSymbols[i].getSprite());

            (function(_this, i, resSymbol, animsSymbol) {

                var symbolData = _this._symbolsManager.getSymbolData(resSymbol);

                var prom = _this.wait(i * 300).then(function() {

                    return _this._appearSymbolAnim(resSymbol, animsSymbol).then(function() {

                        animsSymbol.destroy();
                        resSymbol.destroy();

                        resSymbol = _this._symbolsManager.create(
                            "symbol_Alchemist",
                            symbolData['px'], symbolData['py'],
                            symbolData['rx'], symbolData['ry'],
                            symbolData['spriteName']
                        );

                        _this._reels.symbolsGroup.add(resSymbol.getSprite());

                        resSymbol.createSymbol();
                        _this._reels.addSymbol(resSymbol);
                    });

                });

                proms.push(prom);

            } (this, i, resSymbols[i], animsSymbols[i]));
        }

        Promise.all(proms).then(function() {
            this._resolver();
            //setTimeout(this._resolver, 1000);
        }.bind(this));
    },

    /**
     * @param {AbstractSymbol} resSymbol
     * @param {AbstractSymbol} animsSymbol
     * @returns {Promise}
     */
    _appearSymbolAnim: function(resSymbol, animsSymbol) {

        var _self = this;

        return new Promise(function(resolve) {

            //var reelX = resSymbol.getReelX();
            //var reelY = resSymbol.getReelY();
            var x = resSymbol.getPosX();
            var y = resSymbol.getPosY();

            _self._game.assets.dust(x, y, 4, 60, 0x4cd8eb, 120, _self._reels.animsSymbolsGroup);

            MI.createTimer().add(function() {

                _self._sounds["bonus_Wild_Random"].play();

                //new Promise(function(res) {
                resSymbol.stopStandAnim();
                MI.addTween().to(resSymbol.getSprite(), { 'alpha': 0 }, {
                    'duration': 200,
                    'delay': 300,
                    'callback': function() {
                        resSymbol.destroy();
                    }
                });
                //}).then;

                animsSymbol.createSymbol();
                animsSymbol.setScale(0.4, 0.4);
                animsSymbol.setVisible(true);

                //new Promise(function(res) {

                var shine = MI.addImg(x, y, "random_appear_shine_atlas").setBlend("ADD").setScale(2, 2).setAnchor(0.5, 0.5);
                _self._reels.animsSymbolsGroup.add(shine);
                shine.createAnims();
                shine.anims.add("shine", MI.generateFrameNames("Wild_random-appear_shine_", 1, 45, "", 5));
                shine.anims.play("shine", 85);
                shine.anims.addOnComplete(function() {
                    shine.destroy();
                    //res();
                });
                //});

                //new Promise(function() {

                var circle = MI.addImg(x, y, "random_appear_atlas").setBlend("ADD").setScale(2, 2).setAnchor(0.5, 0.5);
                _self._reels.animsSymbolsGroup.add(circle);
                circle.createAnims();
                circle.anims.add("circle", MI.generateFrameNames("Wild_random-appear_", 0, 54, "", 5));
                circle.anims.play("circle", 85);
                circle.anims.addOnComplete(function() {
                    circle.destroy();
                    //res();
                });
                //});

                //new Promise(function() {
                //setTimeout(function() {
                MI.addTween().to(animsSymbol.getSprite(), { 'x': 1, 'y': 1 }, {
                    'scale': true,
                    'delay': 200,
                    'duration': 1000,
                    'easing': MadnesTween.getEasing('back_out'),
                    'callback': function() {
                        //animsSymbol.setVisible(false);
                        _self._game.assets.colorizeReelFramesBySymbol(animsSymbol);
                        resolve();
                        //res();

                    }
                });
                //}, 100);
                //});
            }, 1200);
        });
    },

    /**
     * @param {AbstractSymbol} symbol
     * @returns {AbstractSymbol}
     */
    _getResSymbol: function(symbol) {
        var reelX = symbol.reelPos['x'];
        var reelY = symbol.reelPos['y'];

        return this._reels.getReel(reelX).reelSymbols[reelY];
    },

    /**
     * @param {ServerResult} serverResult
     * @returns {undefined}
     */
    _animFreeSpins: function(serverResult) {

        madnes_start_freespins();

        var _self = this;

        this._resultController.setDisableFsEnd(true);

        // MI.controls.hideSkip();
        // MI.controls.showStop();

        _self._sounds["bg_Music"].fadeOut(500, true);

        if(this._game.fsChoosed()) {
            this._enterFreeSpins(true);
            return;
        }

        states.setState(STATES.BONUS);
        // MI.controls.hideAllBtns();

        this._optionsBlinkTimer = MI.createTimer();
        this._optionsTimer = MI.createTimer();

        this._game.inBonusChoose = true;

        var resSymbols = this._getResSymbols(this._winline.getPosition());
        var animsSymbols = this._createAnimsSymbols(resSymbols);

        this._fsOptions = [];

        for(var i = 0; i < resSymbols.length; i++) {
            resSymbols[i].createFSAnim();
            this._reels.animsSymbolsGroup.add(resSymbols[i].getSprite());
        }

        this._reels.fadeInBlackScreenPre().then(function() {

            _self._sounds["bonus_Paper_1"].play();

            for(var i = 0; i < animsSymbols.length; i++) {
                (function(resSymbol, animsSymbol, i) {

                    // console.time("s" + i);

                    resSymbol.setVisible(false);
                    animsSymbol.setVisible(true);
                    animsSymbol.createWinSymbol();
                    animsSymbol.playWinAnim().then(function() {

                        animsSymbol.destroy();
                        resSymbol.setVisible(true);
                        resSymbol.playFSAnim();
                    });

                    _self._fsOptions[i] = new FreeSpinOption(_self._game.assets.bonusGroup);
                    _self._fsOptions[i].create(animsSymbol.getPosX(), animsSymbol.getPosY());
                    _self._fsOptions[i].onChoose(function() {

                        _self._chooseFreeSpins(serverResult, i, resSymbols, animsSymbols);

                        for(var j = 0; j < _self._fsOptions.length; j++) {
                            _self._fsOptions[j].disableButton();
                        }
                    });

                } (resSymbols[i], animsSymbols[i], i));
            }

            if(systemConfig.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) {
                setTimeout(()=> _self._fsOptions[getRandomInt(0, animsSymbols.length - 1)].choose(), 10000)
            }

            //var times = shuffleArray([0, 500, 1000]);
            var proms = [];

            _self._fsOptions[0].setFlyTo(MI.getWi() / 2 - 350 / 2 - 200, MI.getHe() / 2 - 40);
            _self._fsOptions[1].setFlyTo(MI.getWi() / 2, MI.getHe() / 2 - 40);
            _self._fsOptions[2].setFlyTo(MI.getWi() / 2 + 350 / 2 + 200, MI.getHe() / 2 - 40);

            for(var i = 0; i < _self._fsOptions.length; i++) {

                (function(i) {

                    var p = _self._fsOptions[i].play((i + 1) * 550, 1).then(function() {

                        // console.timeEnd("s" + i);

                    }.bind(this));/*.then(function() {
						_self._fsOptions[i].levitationStart(i * 100);
					});*/

                    proms.push(p);

                } (i));
            }

            Promise.all(proms).then(function() {
                _self._prepareFreeSpins();
            });
        });
    },

    _prepareFreeSpins: function() {

        var _self = this;

        this._playFreespinParticles();

        for(var i = 0; i < this._fsOptions.length; i++) {
            this._fsOptions[i].button.setVisible(true);
        }

        setTimeout(function() {
            for(var i = 0; i < _self._fsOptions.length; i++) {
                _self._fsOptions[i].enableButton();
            }

            var j = 0;
            //this._blinkFsOptions(j);
            _self._optionsBlinkTimer.loop(function() {
                _self._blinkFsOptions(j++);
            }, 1000);

            // _self._optionsTimer.add(function() {
            //
            // 	var option = getArrayRandValue(_self._fsOptions);
            // 	option.choose();
            //
            // }, _self._chooseTimeout);

        }, 1000);
    },

    _blinkFsOptions: function(j) {
        for(var i = 0; i < this._fsOptions.length; i++) {
            this._fsOptions[i].blink(j);
        }
    },

    _chooseFreeSpins: function(serverResult, index, resSymbols, animsSymbols) {

        MI.setCookie("lfspos_" + MI.server.getSessionId(), -1);

        var choosedFsCount = serverResult.getFreeSpinResults().length;

        var choosedOption = this._fsOptions[index];
        //console.log(option.getTypeNumber());

        this._stopFreespinParticles();

        var game = this._game;
        /** @type {WinControl} */
        var _self = this;

        this._optionsBlinkTimer.stop();
        this._optionsBlinkTimer = null;

        this._optionsTimer.stop();
        this._optionsTimer = null;

        this._sounds["bonus_Scatter_Pick"].play();
        this._sounds["bonus_Paper_2"].play();

        var options = Object.keys(FreeSpinOption.types);
        options.splice(options.indexOf(choosedFsCount + ""), 1);

        // console.log(options, choosedFsCount, FreeSpinOption.types);
        game.assets.createFsInfo();

        choosedOption.choosed = true;
        choosedOption.createPaper(choosedFsCount);


        choosedOption.chooseAnim().then(function() {

            var exposeAnims = [];

            for(var i = 0; i < this._fsOptions.length; i++) {

                var option = this._fsOptions[i];

                if(i != index) {
                    option.createPaper(Math.random() >= 0.5 ? options.pop() : options.shift());
                }

                exposeAnims.push(option.expose());
            }

            return Promise.all(exposeAnims);

        }.bind(this)).then(function() {

            return game.assets.hideLogo().then(function() {
                return game.assets.playFsInfoAnim(0, 0);
            }).then(function() {
                game.assets.countFsInfo(0, choosedFsCount, 0, game);

                return new Promise(function(res) {
                    setTimeout(res, 1000);
                });

            });
        }).then(function() {

            _self._sounds["bonus_Paper_3"].play();

            var proms = [];
            for(var i = 0; i < _self._fsOptions.length; i++) {
                proms.push(_self._fsOptions[i].close());
            }

            return Promise.all(proms);
        }).then(function() {
            for(var i = 0; i < _self._fsOptions.length; i++) {
                _self._fsOptions[i].destroy();
            }

            return _self._reels.fadeOutBlackScreen();
        }).then(function () {

            for(var i = 0; i < animsSymbols.length; i++) {
                animsSymbols[i].destroy();
                resSymbols[i].setVisible(true);
            }

            for(var i = 0; i < resSymbols.length; i++) {
                resSymbols[i].setVisible(true);
                resSymbols[i].playStandAnim();
            }

            _self._enterFreeSpins(false);
        });

        /*var serverWait = MI.server.playersPick(0, data);
        var chooseWait = new Promise(function(res) {
            setTimeout(res, 1500);
        });*/

        // var data = { 'freeSpinChoice': option.getTypeNumber() };

        // MI.server.playersPick(0, data).then(function() {
        // 	return new Promise(function(res) { setTimeout(res, 500); });
        // }).then(function() {
        //
        // 	game.assets.createFsInfo();
        //
        // 	return game.assets.hideLogo().then(function() {
        // 		return game.assets.playFsInfoAnim(0, 0);
        // 	});
        //
        // }).then(function() {
        //
        // 	var servRes = new ServerResult();
        // 	servRes.init(MI.server.getPlayersPick());
        // 	var to = servRes.getFreeSpinResults().length;
        // 	game.assets.countFsInfo(0, to, 0, game);
        //
        // 	return new Promise(function(res) {
        // 		setTimeout(res, 1000);
        // 	});
        // }).then(function() {
        //
        // 	//setTimeout(function() {
        // 		_self._sounds["bonus_Paper_3"].play();
        // 	//}, 2000);
        //
        // 	var proms = [];
        // 	for(var i = 0; i < _self._fsOptions.length; i++) {
        // 		proms.push(_self._fsOptions[i].close());
        // 	}
        //
        // 	return Promise.all(proms);
        //
        // }).then(function() {
        // 	for(var i = 0; i < _self._fsOptions.length; i++) {
        // 		_self._fsOptions[i].destroy();
        // 	}
        //
        // 	return _self._reels.fadeOutBlackScreen();
        //
        // }).then(function() {
        // 	for(var i = 0; i < animsSymbols.length; i++) {
        // 		animsSymbols[i].destroy();
        // 		resSymbols[i].setVisible(true);
        // 	}
        //
        // 	for(var i = 0; i < resSymbols.length; i++) {
        // 		resSymbols[i].setVisible(true);
        // 		resSymbols[i].playStandAnim();
        // 	}
        //
        // 	_self._enterFreeSpins();
        // });
    },

    /**
     * @param {boolean=} pickSkipped
     * @returns {undefined}
     */
    _enterFreeSpins: function(pickSkipped) {

        var _self = this;

        this._game.inBonusChoose = false;
        this._game.enterFreeSpins(pickSkipped).then(function() {
//			setTimeout(function() {
            _self._resolver();
//			}, 1000);
        });
    },

    /**
     * @param {ServerResult} serverResult
     * @returns {undefined}
     */
    _animShuffle: function(serverResult) {
        this._muteBgMusic();
        this._shuffleSymbols(serverResult);
    },

    /**
     * @param {ServerResult} serverResult
     * @returns {undefined}
     */
    _shuffleSymbols: function(serverResult) {

        /** @type {WinControl} */
        var _self = this;

        states.setState(STATES.BONUS);
        // MI.controls.hideAllBtns();

//		MI.createTimer().add(function() {
        _self._sounds["bonus_Wild_Shuffle"].play();
//		}, 200);


        var shuffleSymbols = serverResult.getShuffleSymbols();
        var allResSymbols = this._getAllResSymbols();
        //var animSymbols = this._createAnimsSymbols(allResSymbols);

        this._incControlResultPos();
        //var reelMatrix = this._getReelMatrix(serverResult);

        var mill = this._game.assets.createMill(MI.getWi() / 2, MI.getHe() + 170, false);
        this._game.assets.millGroup.add(mill);

        var prom2 = new Promise(function(res) {


            var alchemist = new Alchemist(_self._game.assets.getAlchemistGroup(), _self._game.assets);
            alchemist.createShuffling();
            alchemist.playShuffling().then(function() {
                _self._game.assets.millFadeInLight();
                _self._game.assets.startSpinMill();
                _self._game.assets.millSpeedUp(8, 2000);

                _self._shuffleSymbolsAnim(shuffleSymbols, allResSymbols).then(res);
            });
        });

        this._game.assets.moveInMill().then(function() {

            MI.createTimer().add(function() {
                for(var i = 0; i < _self._reels.getReels().length; i++) {
                    _self._game.assets.fadeOutColorFrames(_self._reels.getReel(i));
                }
            }, 1000);

            var prom1 = new Promise(function(res) {
                MI.createTimer().add(function() {
                    _self._game.assets.moveOutMill(_self._game.assets.millGroup).then(function() {
                        _self._game.assets.stopSpinMill();
                        _self._game.assets.destroyMill(mill);
                        //MI.controls.showAllBtns();
                        res();
                    });
                }, 4000);
            });

            Promise.all([prom1, prom2]).then(function() {
                _self._resolver();
            });

        });
    },

    /**
     * @param {Array<AbstractSymbol>} shuffleSymbols
     * @param {Array<AbstractSymbol>} animSymbols
     * @returns {Promise}
     */
    _shuffleSymbolsAnim: function(shuffleSymbols, animSymbols) {

        //var allResSymbols = this._getAllResSymbols();

        var shuffling = new Shuffling();
        shuffling.initCirclePoints(MI.getWi() / 2, MI.getHe() / 2 - 40, 180);

        var x = this._game.gameCfg.reelsPositions[0]['x'];
        var y = this._game.gameCfg.reelsPositions[0]['y'] + this._game.gameCfg.symbolHeight
            + this._game.gameCfg.symbolOffsetY;
        var xOffset = this._game.gameCfg.reelsPositions[1]['x'] - this._game.gameCfg.reelsPositions[0]['x'];
        var yOffset = this._game.gameCfg.symbolHeight;

        shuffling.initPositions(x, y, xOffset, yOffset);
        shuffling.setMinSteps(6);
        //shuffling.drawCircle();


        return new Promise(function(res) {

            var shuffles = [];

            for(var i = 0; i < shuffleSymbols.length; i++) {

                var fromX = shuffleSymbols[i][0][0];
                var fromY = shuffleSymbols[i][0][1];
                var toX = shuffleSymbols[i][1][0];
                var toY = shuffleSymbols[i][1][1];

                var animSymbol = this._getIdenticSymbol(animSymbols, fromX, fromY);

                var shuffle = shuffling.createShuffle(animSymbol.getSprite());

                (function(animSymbol, toX, toY) {

                    shuffle.setOnOut(function() {
                        animSymbol.setReelX(toX);
                        animSymbol.setReelY(toY);
                        this._reels.addSymbol(animSymbol);
                        this._game.assets.colorizeReelFramesBySymbol(animSymbol, 300);

                    }.bind(this));

                    var prom = shuffle.run(shuffling.getPath(fromX + "" + fromY, toX + "" + toY));
                    shuffles.push(prom);

                }.bind(this) (animSymbol, toX, toY));
            }

            Promise.all(shuffles).then(res);
        }.bind(this));
    },

    /**
     * @param {Array<AbstractSymbol>} animsSymbols
     * @param {number=} multiplier
     * @returns {undefined}
     */
    _playWinLineTextNormal: function(animsSymbols, multiplier) {

        if(this._resultController.inBigWin) {
            return;
        }

        var wlt = new WinLineText();
        wlt.init(animsSymbols, MI.moneyToCoin(this._winline.getWin()));
        wlt.createWinNormal(multiplier);
        wlt.playWinNormal().then(function() {
            wlt.destroy();
        });
    },

    _getIdenticSymbol: function(symbols, reelX, reelY) {

        for(var i = 0; i < symbols.length; i++) {
            if(symbols[i].getReelX() === reelX && symbols[i].getReelY() === reelY) {
                return symbols[i];
            }
        }

    },

    _animMultiplier: function() {

        // MI.controls.hideAllBtns();
        states.setState(STATES.BONUS);

        this._muteBgMusic();

        this._sounds["win_Multiplier"].play();

        this._game.assets.playMultipler(this._winline.getMultiplier()).then(function() {
            setTimeout(this._resolver, 500);
        }.bind(this));
    },

    end: function() {

        this._bigWinRunned = false;

//		return new Promise(function(res) {
//
//			this._reels.fadeOutBlackScreen().then(res);
//
//
//		}.bind(this));

    },

    wait: function(time) {
        return new Promise(function(res) {
            if(!time) { res(); return; }
            setTimeout(function() { res(); }, time);
        });
    },

    _playFreespinParticles: function() {

        this._playFsParticles = true;

        for(var i = 0; i < 30; i++) {
            var particle = MI.addImg(getRandomInt(50, MI.getWi() - 50), getRandomInt(0, MI.getHe() - 50), "symbols_atlas");
            var scale = getRandomFloat(0.8, 1.5);
            particle.setFrameName("spark_small_turquoise").setScale(scale, scale);
            particle.setAngle(getRandomInt(0, 360)).setAlpha(0); //.setVisible(false);
            particle.setAnchor(0.5, 0.5);
            //this._fsParticles.push(particle);

            this._game.assets.bonusParticlesGroup.add(particle);
            this.fsParticleAnim(particle);
        }

    },

    fsParticleAnim: function(particle) {
        var _self = this;

        if(!this._playFsParticles) {
            if(particle["_particleAnim"]) {
                particle["_particleAnim"].destroy();
            }

            particle["_particleAnim"] = null;

            particle.destroy();
            particle = null;
            return;
        }

        var y = getRandomInt(0, MI.getHe() - 50);
        madnes_set_pos(particle.name, getRandomInt(50, MI.getWi() - 50), y);

        var obj = { 'move': 0, 'alpha': 0, 'angle': 0 };

        particle["_particleAnim"] = MI.addTween().to(obj, { 'move': getRandomInt(60, 160), 'alpha': 3, 'angle': getRandomInt(0, 360) }, {
            'duration': getRandomInt(4000, 8000),
            'update': function() {

                madnes_set_pos_y(particle.name, y + obj['move'], true);
                madnes_set_angle(particle.name, obj['angle']);

                //console.log(obj['alpha']);

                if(obj['alpha'] <= 0.3) {
                    madnes_set_alpha(particle.name, obj['alpha'] / 0.3);
                    //console.log(obj['alpha'] / 0.3);
                }

                if(obj['alpha'] > 0.3 && obj['alpha'] < 2.7) {
                    madnes_set_alpha(particle.name, 1);
                }

                if(obj['alpha'] >= 2.7) {
                    madnes_set_alpha(particle.name, (3 - obj.alpha) / 0.3);
                    //console.log((3 - obj.alpha) / 0.2);
                }

            },
            'callback': function() {
                madnes_set_alpha(particle.name, 0);
                _self.fsParticleAnim(particle);
            }
        });

    },

    _stopFreespinParticles: function() {

        this._playFsParticles = false;

        /*for(var i = 0; i < this._fsParticles.length; i++) {
            this._fsParticles[i]["_particleAnim"].stop();
            this._fsParticles[i].destroy();
        }

        this._fsParticles[i]*/

    }

};

